import React from 'react'
import PropTypes from 'prop-types'
import FormSelect from 'components/FormSelect'
import {reduxForm, Field, reset} from 'redux-form'
import {editCountryLimitList} from 'redux/modules/sites/actions'
import * as _ from 'lodash'

import {countries} from 'countries-list/cjs'

const countryList = _.chain(countries).map((info, code) => {
  return {
    name: info.name,
    value: code
  }
}).sortBy('name').value()

export class AddRegionForm extends React.Component {
  static propTypes = {
    countriesLimit: PropTypes.array,
    countriesData: PropTypes.array,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool
  }

  render() {
    const {handleSubmit, invalid, countriesLimit, countriesData} = this.props
    const options = _.filter(countryList, item => {
      return !countriesLimit.includes(item.value) && countriesData.includes(item.value)
    })

    return (
      <form
        className='settings-region-view_add-form'
        onSubmit={handleSubmit}
      >
        <label htmlFor='regex'>Select country</label>
        <Field
          className='settings-region-view_add-form_select-contry'
          name='country'
          searchable
          component={FormSelect}
          emptyValue=' '
          options={options}
        />
        <button type='submit' disabled={invalid}>
          Add
        </button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'addRegionForm',
  validate: ({country}, props) => {
    const errors = {}
    if (!country) {
      errors.country = 'Country is required'
    }

    return errors
  },
  onSubmit: ({country}, dispatch, props) => {
    const {siteId, countriesLimit = []} = props
    dispatch(
      editCountryLimitList({
        id: siteId,
        countriesLimit: [...countriesLimit, country]
      })
    )
    dispatch(reset('addRegionForm'))
  }
})(AddRegionForm)



// WEBPACK FOOTER //
// ./client/views/SettingsRegionView/AddRegionForm.js